import React, { useEffect, useState } from "react";
import styles from "./BookConsulationPage.module.css";
import MobileImage from "../../assets/quote/mobilerightSideImageSec04.png";
import SubdirectoryArrowLeftIcon from "@mui/icons-material/SubdirectoryArrowLeft";
import CallIcon from "@mui/icons-material/Call";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// ✅ Text changer
const ChangingText = () => {
  const texts = [
    "Web Development",
    "Website Development",
    "E-commerce",
    "UI/UX Designs",
    "Mobile App",
  ];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return <span className={styles.changingText}>{texts[index]}</span>;
};

// ✅ Main Component
const HeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // only animate once when in view
      offset: 100, // how far from the top before triggering
    });
  }, []);

  return (
    <section className={styles.heroSection}>
      <div className={styles.contentWrapper}>
        <div className={styles.textContent} data-aos="fade-up">
          <h1 className={styles.heading}>
            We're Ready to Bring, </h1>
            <br />
            Your Ideas to Life -
            <h2
              className={styles.subHeading}
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <ChangingText />
            </h2>
          
          <p
            className={styles.qouteDescription}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Have an idea or need expert guidance?{" "}
            <SubdirectoryArrowLeftIcon className="callButtonIcon" />
          </p>
       
          <Link to="/contactform">
            <button
              data-aos="zoom-in"
              data-aos-delay="700"
              className="talkToOurExpertButton border-gradient border-gradient-purple"
            >
              Schedule a call with us ....!
            </button>
          </Link>
          <p className={styles.quote} data-aos="fade-up" data-aos-delay="900">
            &quot;Save time, Grow profits, and scale your Business&quot;
          </p>
        </div>
      </div>

      <div className={styles.imageSection} data-aos="fade-right">
        <img src={MobileImage} alt="Mobile" className={styles.mobileImage} />

        {/* Optional SVG Section */}
        <div
          dangerouslySetInnerHTML={{
            __html: `
              <svg ...>Your SVG Here</svg>
            `,
          }}
        />
      </div>
    </section>
  );
};

export default HeroSection;
